/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { escape } from '../../../common/strings.js';
export function renderOcticons(text) {
    return escape(text);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/base/browser/ui/octiconLabel/octiconLabel.js
// module id = 484
// module chunks = 53